(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["block-fabric-samples"] && !Shopify.designMode) return;
  try {
    

    var largestWidth = 0;
    var headings = document.querySelectorAll(".b-fabric-samples__content__item__heading");
    headings.forEach(item => {
        if(item.offsetWidth > largestWidth) {
            largestWidth = item.offsetWidth;
        }
    })
    headings.forEach(item => {
        item.style.minWidth = largestWidth + "px";
    })    
  
    // document.querySelector('.c-navbar').style.backgroundColor = '#848F87'
  
    // #F6F2ED
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-hero"] && !Shopify.designMode) return;
  try {
    

  if(document.querySelector('.b-hero__image')) {
    document.querySelector('body').classList.add('has-hero-image');
  }

  if(document.querySelector('.b-hero__image')) {
    var collection_top_area = document.querySelector('.collection__top-area .c-breadcrumb ');
    if(collection_top_area != null) {
      document.querySelector('.collection__top-area .c-breadcrumb ').style.display = 'none'
    }
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["block-wysiwyg"] && !Shopify.designMode) return;
  try {
    

  if(document.querySelector('.b-hero__image')) {
    document.querySelector('body').classList.add('has-hero-image');
  }

  if(document.querySelector('.b-hero__image')) {
    var collection_top_area = document.querySelector('.collection__top-area .c-breadcrumb ');
    if(collection_top_area != null) {
      document.querySelector('.collection__top-area .c-breadcrumb ').style.display = 'none'
    }    
  }
  

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  var loadProductRecommendationsIntoSection = function() {
    // Look for an element with class 'product-recommendations'
    var productRecommendationsSection = document.querySelector(".product-recommendations");
    if (productRecommendationsSection === null) { return; }
    // Read product id from data attribute
    var productId = productRecommendationsSection.dataset.productId;
    // Read limit from data attribute
    var limit = productRecommendationsSection.dataset.limit;
    // Build request URL
    var requestUrl = "/recommendations/products?section_id=product-recommendations&limit="+limit+"&product_id="+productId;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();
    request.open("GET", requestUrl);
    request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
        var container = document.createElement("div");
        container.innerHTML = request.response;
        productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;

        let attempts = 0;
        const maxAttempts = 30;
        const interval = 500; // ms

        const tryInit = () => {
        try {
            window.productSliderWide.initialise();
            clearInterval(retryInterval); // ✅ Success, stop trying
        } catch (e) {
            attempts++;
            if (attempts >= maxAttempts) {
            clearInterval(retryInterval);
            console.warn("Failed to initialize product slider or card after 10 tries.");
            }
        }
        };

        const retryInterval = setInterval(tryInit, interval);
        tryInit(); // ✅ Try immediately as well
    }
    };
    request.send();
  };
  // If your section has theme settings, the theme editor
  // reloads the section as you edit those settings. When that happens, the
  // recommendations need to be fetched again.
  // See https://help.shopify.com/en/themes/development/sections/integration-with-theme-editor
  document.addEventListener("shopify:section:load", function(event) {
    if (event.detail.sectionId === "product-recommendations") {
      loadProductRecommendationsIntoSection();
    }
  });
  // Fetching the recommendations on page load
  loadProductRecommendationsIntoSection();


  
  } catch(e) { console.error(e); }
})();
})();
